import { Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { ApiService, IPagingParameters, ISearchDeviceEventsRequest } from '../api';
import { DateTimeService } from './date-time.service';
import { IUnacknowledgedAlarmsReceivedArgs } from './interfaces';
import { ObservablesService } from './observables.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { alarmNotificationPopupComponent } from './alarm-notification-popup/alarm-notification-popup';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { Queue } from 'queue-typescript';
import { DeviceEventType, IDeviceEvent } from '../api';
import { NotificationsService, TokenService, TranslationKey } from '../shared';
import { AlarmTypeTranslationService } from './alarm-type-translation.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})

export class DeviceEventsPollerService {
  private minPollInterval = 5000;
  private pollInterval = 5000;
  private intervalSubscription: Subscription | null = null;
  private polling = false;
  private sinceDateNotification?: string = undefined;
  private dataObjectqueue = new Queue<any>();
  private getUserProfileSettings:any ={};

  constructor(private apiSvc: ApiService, private obsSvc: ObservablesService, private dateTimeSvc: DateTimeService, private snackBar: MatSnackBar, private alarmtransSvc: AlarmTypeTranslationService, private notificationsSvc: NotificationsService, private transSvc: TranslocoService, private tokenSvc: TokenService) {
  }

  async start(pollInterval: number): Promise<void> {
    this.stop();
    await this.getuserProfileSettings();
    this.pollInterval = pollInterval;
    if (this.pollInterval < this.minPollInterval) {
      this.pollInterval = this.minPollInterval;
    }
    this.sinceDateNotification=this.dateTimeSvc.getNowAsString();
    this.intervalSubscription = interval(this.pollInterval).subscribe(_ => this.pollDeviceEvents());
  }

  stop(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
    this.polling = false;
  }

  private async pollDeviceEvents(): Promise<void> {
    if (this.polling) {
      return;
    }
    this.polling = true;
    try {
      // The badge count is number of alarms that are still unacknowledged
      const pagingParameters: IPagingParameters = { offset: 0, maxItems: 1 };
      const req: ISearchDeviceEventsRequest = { acknowledged: false };
      const res = await this.apiSvc.searchDeviceEvents(pagingParameters, req);
      const args: IUnacknowledgedAlarmsReceivedArgs = { count: res.totalItems };
      this.obsSvc.setUnacknowledgedAlarmsReceived(args);
      this.pollDeviceEventsNotifications();
    } catch {
    }
    this.polling = false;
  }

  private async pollDeviceEventsNotifications (): Promise<void> {
    if (!this.getUserProfileSettings)
      return;
    const pagingParameters: IPagingParameters = { offset: 0, maxItems: 50 };
    const req: ISearchDeviceEventsRequest = { since: this.sinceDateNotification};
    const res = await this.apiSvc.searchDeviceEvents(pagingParameters, req);
    const hasItems = res.items.length > 0;
    if (hasItems)
      this.sinceDateNotification= res.items[0].dateTime;
    var dataObject:any=[];
    var eventItemFilteredKey,eventItemFiltered,selectAllFilter:any=[];
    var eventItems=res.items;
    // var eventItems = this.eventItems;
    var getItemObjKeys = Object.keys(this.getUserProfileSettings);
    if(getItemObjKeys.includes('0.0.0')){
      eventItemFilteredKey=eventItems;
      selectAllFilter = await eventItemFilteredKey.filter((ele:any) => this.getUserProfileSettings['0.0.0']?.some((ele2:any)=> (String(ele2) === String(ele.type)) || (String(ele2) === '255')  ));
    }
    else{
      eventItemFilteredKey= await eventItems.filter((ele:any) => getItemObjKeys.some((ele2:any)=> String(ele2) === String(ele.sourcePAIPAddress) ));
    }
    eventItemFiltered = await eventItemFilteredKey.filter((ele:any) => this.getUserProfileSettings[ele.sourcePAIPAddress]?.some((ele2:any)=> (String(ele2) === String(ele.type)) || (String(ele2) === '255')  ));
    if(selectAllFilter.length>0){
      var eventItemFilter=[...eventItemFiltered,...selectAllFilter];
      eventItemFiltered = eventItemFilter.filter((obj, index) => {
        return index === eventItemFilter.findIndex(o => obj.id === o.id);
      });
    }
    await eventItemFiltered.reverse().forEach(async(element:any,index:number) => {
      var objectEle:any={};
      objectEle['type'] = await this.alarmtransSvc.translateDeviceEventType(element.type);
      objectEle['deviceId'] = element.sourcePAIPAddress;
      objectEle['parameter'] = element.parameters;
      objectEle['routerLinkText'] = 'Go to Alarms Page';
      objectEle['routerLinkUrl'] = 'device-alarm-list';
      dataObject.push(objectEle);
      this.dataObjectqueue.enqueue(objectEle);
    });
    let snackTimer = timer(0, 3000).pipe(
      take(dataObject.length)
    );
    let sub = snackTimer.subscribe(i => {
      this.openSnackBar(this.dataObjectqueue.dequeue());
      if (i == dataObject.length) {
        sub.unsubscribe();
      }
    });
  }

  openSnackBar(dataObject:any){
    this.snackBar.openFromComponent(alarmNotificationPopupComponent,{
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: 'icu-alarm-toast-panel',
      data: dataObject
    });
  }

  async getuserProfileSettings(){
    const userProfileSettingsRes = await this.apiSvc.getUserProfileSettings(this.tokenSvc.getUserId()!);
    var data = userProfileSettingsRes.alarmNotificationSettings;
    this.getUserProfileSettings=undefined;
    if (data != null) {
      try {
        const jsonObject = JSON.parse(data);
        this.getUserProfileSettings =jsonObject;
      }
      catch(err) {
        // await this.notificationsSvc.showError(this.transSvc.translate(TranslationKey.invalidUserProfileSettings));
      }
    }
    else if (data === null){
    }
    return;
  }

  async updateUserProfileSettings(newSettings:any){
    this.getUserProfileSettings = newSettings;
    return;
  }

}